/* You can add your custom scripts here */

/* =============================================================
   Safari: Quantity Picker — JS fallback
   If the ProductQuantityPicker custom element failed to initialize
   (base.js syntax error in Safari < 14.1), the +/- spans have no
   click handlers. We detect this by checking for the `onClick`
   instance field the class sets during construction.
   If missing → custom element never upgraded → attach our own handlers.
   ============================================================= */
(function () {
  function initQtyFallback() {
    document.querySelectorAll('.product-quantity-picker').forEach(function (picker) {
      /* Custom element sets `onClick` as a class instance field in its constructor.
         If it exists, the element was properly upgraded — skip. */
      if (picker.hasOwnProperty('onClick')) return;

      var minus = picker.querySelector('.qty-minus');
      var plus  = picker.querySelector('.qty-plus');
      var input = picker.querySelector('input[type="number"]');
      if (!minus || !plus || !input) return;

      minus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        var min = parseInt(input.min, 10);
        if (isNaN(min) || val > min) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        var max = parseInt(input.max, 10);
        if (isNaN(max) || val < max) {
          input.value = val + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  /* custom.js is loaded (deferred) before base.js, which is where
     `customElements.define('product-quantity-picker', ...)` lives.
     Checking hasOwnProperty('onClick') right away always sees an
     un-upgraded element — base.js hasn't run yet — so the fallback
     attaches handlers unconditionally. Then base.js loads and defines
     the custom element, which upgrades the still-present DOM nodes
     and attaches its own handlers on top, doubling every click.
     Waiting for `window.load` guarantees base.js has already run
     (and either upgraded the element or genuinely failed to) before
     we decide whether the fallback is needed. */
  if (document.readyState === 'complete') {
    initQtyFallback();
  } else {
    window.addEventListener('load', initQtyFallback);
  }
})();

/* =============================================================
   Nav Dropdown — Hover Preview Panel
   Reads collection <img> tags injected by Liquid (primary_menu_collection_image_display),
   hides them in the list, and shows the hovered category's image in a right-side panel.
   Desktop only (CSS controls display; JS just builds the DOM).
   ============================================================= */
(function () {
  function initNavPreview() {
    var navItems = document.querySelectorAll('.section-header nav > ul > li:not(.has-megamenu)');

    navItems.forEach(function (li) {
      var dropdown = li.querySelector(':scope > ul');
      if (!dropdown) return;

      /* Collect subitem <a> tags that have a hidden preview image */
      var subLinks = dropdown.querySelectorAll(':scope > li > a');
      var items = [];
      subLinks.forEach(function (a) {
        var img = a.querySelector('.nav-subitem-preview-img');
        if (img && img.src) items.push({ link: a, src: img.src, alt: img.alt || '' });
      });
      if (items.length === 0) return;

      li.classList.add('has-preview-dropdown');
      dropdown.classList.add('has-nav-preview');

      /* Wrapper div = the unified white box.
         We move the <ul> inside it and add the image panel as a sibling.
         The wrapper handles positioning and show/hide — the <ul> is static inside.
         This avoids fighting the theme's ::before pseudo-element box approach. */
      var wrapper = document.createElement('div');
      wrapper.className = 'nav-preview-wrapper';

      var panel = document.createElement('div');
      panel.className = 'nav-preview-panel';
      panel.setAttribute('aria-hidden', 'true');

      var previewImg = document.createElement('img');
      previewImg.src = items[0].src;
      previewImg.alt = items[0].alt;
      previewImg.className = 'nav-preview-panel__img';
      panel.appendChild(previewImg);

      /* Insert wrapper before the <ul>, then move <ul> + panel into it */
      li.insertBefore(wrapper, dropdown);
      wrapper.appendChild(dropdown);
      wrapper.appendChild(panel);

      items[0].link.classList.add('nav-preview-active');

      /* Hover: fade out → swap src → fade in */
      items.forEach(function (item) {
        item.link.addEventListener('mouseenter', function () {
          previewImg.style.opacity = '0';
          setTimeout(function () {
            previewImg.src = item.src;
            previewImg.alt = item.alt;
            previewImg.style.opacity = '1';
          }, 80);
          items.forEach(function (it) { it.link.classList.remove('nav-preview-active'); });
          item.link.classList.add('nav-preview-active');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavPreview);
  } else {
    initNavPreview();
  }
})();

/* =============================================================
   Desktop Search — Icon-only toggle (≥768px)
   The header search box is visually collapsed to just the icon
   (see custom.css). Clicking it forwards a click to the hidden
   search input, reusing the existing search-dropdown component's
   own click handler (base.js) to open/focus it — same predictive
   search behavior as before, just triggered from the icon.
   ============================================================= */
(function () {
  function initSearchIconToggle() {
    document.querySelectorAll('.search-dropdown-header-form .search-dropdown-form-label-icon').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var dropdown = btn.closest('search-dropdown');
        var input = dropdown && dropdown.querySelector('input[type="search"]');
        if (!input) return;
        if (dropdown.classList.contains('active')) {
          input.focus();
        } else {
          input.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchIconToggle);
  } else {
    initSearchIconToggle();
  }
})();

/* =============================================================
   Mobile Search — Slide-down overlay (≤767px)
   Toggles .is-open on #mobileSearchOverlay; auto-focuses input.
   Close on back-arrow click, Escape key, or overlay outside tap.
   ============================================================= */
(function () {
  function initMobileSearch() {
    var toggle  = document.getElementById('mobileSearchToggle');
    var overlay = document.getElementById('mobileSearchOverlay');
    var input   = document.getElementById('mobileSearchInput');
    var close   = document.getElementById('mobileSearchClose');
    if (!toggle || !overlay) return;

    function openSearch() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      if (input) setTimeout(function() { input.focus(); }, 50);
    }
    function closeSearch() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      if (input) input.value = '';
    }

    toggle.addEventListener('click', openSearch);
    if (close) close.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileSearch);
  } else {
    initMobileSearch();
  }
})();

/* =============================================================
   ATC Button — Loading spinner
   Fires in capture phase so it runs before base.js bubble handler.
   Clears when cart-drawer becomes active (success) or an error
   paragraph is injected (failure). 5s safety timeout as fallback.
   ============================================================= */
(function () {
  var STICKY_BTN = '.product-sticky-bar-add-to-cart';
  var safetyTimer = null;

  function getMainAtcBtn() {
    var action = document.querySelector('.product-summary__action');
    if (!action) return null;
    return action.querySelector('.product-summary__add-to-cart, #AddToCart');
  }

  function getButtons() {
    return {
      main: getMainAtcBtn(),
      sticky: document.querySelector(STICKY_BTN),
    };
  }

  function setLoading(on) {
    clearTimeout(safetyTimer);
    var btns = getButtons();

    [btns.main, btns.sticky].forEach(function (btn) {
      if (!btn) return;
      btn.classList.toggle('is-loading', on);
    });

    if (on) {
      safetyTimer = setTimeout(function () { setLoading(false); }, 6000);
    }
  }

  window.howAtcLoader = { setLoading: setLoading };

  function isMainAtcClick(target) {
    var btn = target.closest('.product-summary__add-to-cart, #AddToCart');
    return btn && btn.closest('.product-summary__action') ? btn : null;
  }

  /* Trigger loading on ATC or sticky-ATC click (capture phase = before base.js) */
  document.addEventListener('click', function (e) {
    var mainBtn = isMainAtcClick(e.target);
    var stickyBtn = e.target.closest(STICKY_BTN);

    if (mainBtn || stickyBtn) {
      var atc = mainBtn || getMainAtcBtn();
      if (atc && !atc.hasAttribute('disabled')) {
        setLoading(true);
      }
    }
  }, true /* capture */);

  /* Watch cart-drawer for the 'active' class — base.js adds it on success */
  document.addEventListener('DOMContentLoaded', function () {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            if (cartDrawer.classList.contains('active')) {
              setLoading(false);
            }
          }
        });
      }).observe(cartDrawer, { attributes: true });
    }

    /* Also clear on error paragraph inserted by base.js */
    var actionArea = document.querySelector('.product-summary__action');
    if (actionArea) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1 && node.classList.contains('error')) {
              setLoading(false);
            }
          });
        });
      }).observe(actionArea, { childList: true });
    }
  });
})();
